import { render, staticRenderFns } from "./CapacidadeFaturamento.vue?vue&type=template&id=d3095760"
import script from "./CapacidadeFaturamento.vue?vue&type=script&lang=js"
export * from "./CapacidadeFaturamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports